enum TransactionFor {
  EoiAmount = 'EoiAmount',
  BalanceAmount = 'BalanceAmount',
}

export default TransactionFor;
